import { useEffect, useState } from 'react'

export const isDebug = () =>
  import.meta.env.MODE === 'development' || window.location.hash === '#debug'

export function useDebug() {
  const [debug, setDebug] = useState(isDebug())

  useEffect(() => {
    const handler = () => setDebug(window.location.hash === '#debug')
    window.addEventListener('hashchange', handler)
    return () => window.removeEventListener('hashchange', handler)
  }, [])

  return debug
}
